<template>
  <div class="overflow-auto w-full h-full relative bg-white rounded-md">
    <div class="font-bold pl-[16px] pb-3 pt-3 dark:text-dark-body-text">
      {{ label ? label : $t("Forecast Status") }}
    </div>
    <table class="min-w-full table-fixed">
      <tbody
        class="h-full transition ease-in-out divide-y rounded-lg bg-light-box-background divide-light-divider-border dark:divide-dark-divider-border dark:bg-dark-box-background duration-side-menu-transition-duration">
        <tr class="w-full text-md font-bold transition ease-in-out rounded-lg shadow-sm text-gray-400 dark:text-dark-body-text">
          <td class="px-6 py-3 h-12">
            {{ $t("Name") }}
          </td>
          <td class="px-6 py-3 h-12">
            {{ $t("Actual") }}
          </td>
          <td class="px-6 py-3 h-12">
            {{ $t("Forecast") }}
          </td>
          <td class="px-6 py-3 h-12">
            {{ $t("Target") }}
          </td>
          <td class="px-1 py-3 h-12" />
        </tr>
        <tr
          v-for="metric in metricsTable"
          :key="metric.metricName"
          class="w-full font-bold text-sm transition ease-in-out rounded-lg shadow-sm text-light-body-text dark:text-dark-body-text">
          <td class="px-6 py-3 h-12">
            {{ metric.label }}
          </td>
          <td class="px-6 py-3 h-12">
            <div class="mt-1 flex items-center content-center gap 1">
              <div
                v-if="
                  metric?.children?.length &&
                    (!Object.keys(metric.children[0]).includes('edit') ||
                      (Object.keys(metric.children[0]).includes('edit') && metricEdit != metric.metricName))
                "
                class="text-[20px] flex max-w[30x] font-normal text-grey-light-body dark:text-dark-body-text">
                <span v-if="metric.symbolPre?.length">{{ metric.symbolPre }}</span>
                <span v-if="!(metric.symbolPre || metric.symbolPost)">{{ metric.children[0]?.value }}</span>
                <span v-if="metric.symbolPre || metric.symbolPost">{{
                  $utils.truncateNumber(
                    Number(metric.children[0]?.value?.toString().replaceAll(",", "")?.replace("$", "")?.replace("%", "").replace("-", ""))
                  )
                }}</span>
                <span v-if="metric.symbolPost?.length">{{ metric.symbolPost }}</span>
              </div>
              <div
                v-if="
                  metric?.children?.length &&
                    (!Object.keys(metric.children[0]).includes('edit') ||
                      (Object.keys(metric.children[0]).includes('edit') && metricEdit != metric.metricName))
                "
                class="ml-1 p-1 flex items-center content-center rounded-full"
                :class="
                  metric.children[0]?.value
                    ? metric.children[0]?.value?.toString().includes('-')
                      ? '!bg-status-error-red-transparent'
                      : '!bg-status-success-green-transparent'
                    : ''
                ">
                <ChevronDown
                  v-if="metric.children[0]?.value && metric.children[0]?.value?.toString().includes('-')"
                  class="h-3 w-3"
                  :class="
                    metric.children[0]?.value
                      ? metric.children[0]?.value.toString().includes('-')
                        ? '!text-status-error-red'
                        : '!text-status-success-green'
                      : '!text-status-warning-yellow'
                  " />
                <ChevronUp
                  v-if="metric.children[0]?.value && !metric.children[0]?.value?.toString().includes('-')"
                  class="h-3 w-3"
                  :class="
                    metric.children[0]?.value
                      ? metric.children[0]?.value.toString().includes('-')
                        ? '!text-status-error-red'
                        : '!text-status-success-green'
                      : '!text-status-warning-yellow'
                  " />
                <div
                  v-if="metric.children[0]?.value"
                  class="text-sm pr-1 text-center flex"
                  :class="
                    metric.children[0]?.value
                      ? metric.children[0]?.value?.toString().includes('-')
                        ? '!text-status-error-red'
                        : '!text-status-success-green'
                      : '!text-status-warning-yellow'
                  ">
                  <span v-if="metric.symbolPre?.length">{{ metric.symbolPre }}</span>
                  <span v-if="metric.children[0]?.value?.toString().includes('$')">$</span>
                  {{
                    $utils.truncateNumber(
                      Number(metric.children[0]?.value?.toString().replaceAll(",", "")?.replace("$", "")?.replace("%", "").replace("-", ""))
                    )
                  }}
                  <!--                {{ $utils.truncateNumber($utils.slugify(metric.children[0].value)) }}-->
                  <span v-if="metric.children[0]?.value?.toString().includes('%')">%</span>
                  <span v-if="metric.symbolPost?.length">{{ metric.symbolPost }}</span>
                </div>
                <div v-else class="-ml-2 text-common-grey w-32 flex flex-nowrap">
                  <span>{{ $t("No available data") }}</span>
                </div>
              </div>
              <div
                v-if="
                  metric?.children?.length &&
                    Object.keys(metric.children[0]).includes('edit') &&
                    metricEdit == metric.metricName &&
                    is_range_target_edit
                "
                class="mt-[5px] flex flex-row justify-start h-[25px] items-center">
                <input
                  :disabled="editing_disabled"
                  :value="metric.children[0].value"
                  type="number"
                  min="0"
                  class="w-[100px] h-[25px] appearance-none block mt-1 px-3 py-2 border border-light-divider-border dark:border-dark-divider-border rounded-md shadow-sm dark:bg-dark-box-background placeholder-common-grey text-light-body-text dark:text-dark-body-text focus:outline-none focus:ring-0 dark:focus:ring-dark-brand-blue focus:border-light-brand-blue dark:focus:border-dark-brand-blue text-sm transition ease-in-out duration-200 min-h-[42px]"
                  :placeholder="$t('Target')"
                  @input.prevent=""
                  @keyup.esc="toggleMetricEdit"
                  @keyup.enter="toggleMetricEdit"
                  @focusout="(event) => handleChange(event, metric.children[0])">
                <Check
                  class="hover:bg-gray-100 dark:hover:bg-dark-screen-background text-gray-500 h-10 w-10 block z-40 transition rounded-md duration-500 ease-in-out p-2 ml-1"
                  aria-hidden="true"
                  @click="toggleMetricEdit" />
                <span class="whitespace-nowrap text-sm mx-1 font-thin italic">
                  {{ selectedRange?.start.format("MM/DD/YY") }} - {{ selectedRange?.end.format("MM/DD/YY") }}
                </span>
              </div>
              <div
                v-else-if="metric?.children?.length && Object.keys(metric.children[0]).includes('edit') && metricEdit == metric.metricName"
                class="mt-[5px] flex flex-row justify-start h-[25px] items-center">
                <input
                  :disabled="editing_disabled"
                  :value="metric.children[0].value"
                  type="number"
                  min="0"
                  class="w-[100px] h-[25px] appearance-none block mt-1 px-3 py-2 border border-light-divider-border dark:border-dark-divider-border rounded-md shadow-sm dark:bg-dark-box-background placeholder-common-grey text-light-body-text dark:text-dark-body-text focus:outline-none focus:ring-0 dark:focus:ring-dark-brand-blue focus:border-light-brand-blue dark:focus:border-dark-brand-blue text-sm transition ease-in-out duration-200 min-h-[42px]"
                  :placeholder="$t('Target')"
                  @input.prevent=""
                  @keyup.esc="toggleMetricEdit"
                  @keyup.enter="toggleMetricEdit"
                  @focusout="(event) => handleChange(event, metric.children[0])">
                <Check
                  class="hover:bg-gray-100 dark:hover:bg-dark-screen-background text-gray-500 h-10 w-10 block z-40 transition rounded-md duration-500 ease-in-out p-2 ml-1"
                  aria-hidden="true"
                  @click="toggleMetricEdit" />
              </div>
            </div>
          </td>
          <td class="px-6 py-3 h-12">
            <div class="mt-1 flex items-center content-center gap 1">
              <div
                v-if="
                  metric?.children?.length &&
                    (!Object.keys(metric.children[1]).includes('edit') ||
                      (Object.keys(metric.children[1]).includes('edit') && metricEdit != metric.metricName))
                "
                class="text-[20px] flex max-w[30x] font-normal text-grey-light-body dark:text-dark-body-text">
                <span v-if="metric.symbolPre?.length">{{ metric.symbolPre }}</span>
                <span v-if="!(metric.symbolPre || metric.symbolPost)">{{ metric.children[1]?.value }}</span>
                <span v-if="metric.symbolPre || metric.symbolPost">{{
                  $utils.truncateNumber(
                    Number(metric.children[1]?.value?.toString().replaceAll(",", "")?.replace("$", "")?.replace("%", "").replace("-", ""))
                  )
                }}</span>
                <span v-if="metric.symbolPost?.length">{{ metric.symbolPost }}</span>
              </div>
              <div
                v-if="
                  metric?.children?.length &&
                    (!Object.keys(metric.children[1]).includes('edit') ||
                      (Object.keys(metric.children[1]).includes('edit') && metricEdit != metric.metricName))
                "
                class="ml-1 p-1 flex items-center content-center rounded-full"
                :class="
                  metric.children[1]?.value
                    ? metric.children[1]?.value?.toString().includes('-')
                      ? '!bg-status-error-red-transparent'
                      : '!bg-status-success-green-transparent'
                    : ''
                ">
                <ChevronDown
                  v-if="metric.children[1]?.value && metric.children[1]?.value?.toString().includes('-')"
                  class="h-3 w-3"
                  :class="
                    metric.children[1]?.value
                      ? metric.children[1]?.value.toString().includes('-')
                        ? '!text-status-error-red'
                        : '!text-status-success-green'
                      : '!text-status-warning-yellow'
                  " />
                <ChevronUp
                  v-if="metric.children[1]?.value && !metric.children[1]?.value?.toString().includes('-')"
                  class="h-3 w-3"
                  :class="
                    metric.children[1]?.value
                      ? metric.children[1]?.value.toString().includes('-')
                        ? '!text-status-error-red'
                        : '!text-status-success-green'
                      : '!text-status-warning-yellow'
                  " />
                <div
                  v-if="metric.children[1]?.value"
                  class="text-sm pr-1 text-center flex"
                  :class="
                    metric.children[1]?.value
                      ? metric.children[1]?.value?.toString().includes('-')
                        ? '!text-status-error-red'
                        : '!text-status-success-green'
                      : '!text-status-warning-yellow'
                  ">
                  <span v-if="metric.symbolPre?.length">{{ metric.symbolPre }}</span>
                  <span v-if="metric.children[1]?.value?.toString().includes('$')">$</span>
                  {{
                    $utils.truncateNumber(
                      Number(metric.children[1]?.value?.toString().replaceAll(",", "")?.replace("$", "")?.replace("%", "").replace("-", ""))
                    )
                  }}
                  <!--                {{ $utils.truncateNumber($utils.slugify(metric.children[1].value)) }}-->
                  <span v-if="metric.children[1]?.value?.toString().includes('%')">%</span>
                  <span v-if="metric.symbolPost?.length">{{ metric.symbolPost }}</span>
                </div>
                <div v-else class="-ml-2 text-common-grey w-32 flex flex-nowrap">
                  <span>{{ $t("No available data") }}</span>
                </div>
              </div>
              <div
                v-if="
                  metric?.children?.length &&
                    Object.keys(metric.children[1]).includes('edit') &&
                    metricEdit == metric.metricName &&
                    is_range_target_edit
                "
                class="mt-[5px] flex flex-row justify-start h-[25px] items-center">
                <input
                  :disabled="editing_disabled"
                  :value="metric.children[1].value"
                  type="number"
                  min="0"
                  class="w-[100px] h-[25px] appearance-none block mt-1 px-3 py-2 border border-light-divider-border dark:border-dark-divider-border rounded-md shadow-sm dark:bg-dark-box-background placeholder-common-grey text-light-body-text dark:text-dark-body-text focus:outline-none focus:ring-0 dark:focus:ring-dark-brand-blue focus:border-light-brand-blue dark:focus:border-dark-brand-blue text-sm transition ease-in-out duration-200 min-h-[42px]"
                  :placeholder="$t('Target')"
                  @input.prevent=""
                  @keyup.esc="toggleMetricEdit"
                  @keyup.enter="toggleMetricEdit"
                  @focusout="(event) => handleChange(event, metric.children[1])">
                <Check
                  class="hover:bg-gray-100 dark:hover:bg-dark-screen-background text-gray-500 h-10 w-10 block z-40 transition rounded-md duration-500 ease-in-out p-2 ml-1"
                  aria-hidden="true"
                  @click="toggleMetricEdit" />
                <span class="whitespace-nowrap text-sm mx-1 font-thin italic">
                  {{ selectedRange?.start.format("MM/DD/YY") }} - {{ selectedRange?.end.format("MM/DD/YY") }}
                </span>
              </div>
              <div
                v-else-if="metric?.children?.length && Object.keys(metric.children[1]).includes('edit') && metricEdit == metric.metricName"
                class="mt-[5px] flex flex-row justify-start h-[25px] items-center">
                <input
                  :disabled="editing_disabled"
                  :value="metric.children[1].value"
                  type="number"
                  min="0"
                  class="w-[100px] h-[25px] appearance-none block mt-1 px-3 py-2 border border-light-divider-border dark:border-dark-divider-border rounded-md shadow-sm dark:bg-dark-box-background placeholder-common-grey text-light-body-text dark:text-dark-body-text focus:outline-none focus:ring-0 dark:focus:ring-dark-brand-blue focus:border-light-brand-blue dark:focus:border-dark-brand-blue text-sm transition ease-in-out duration-200 min-h-[42px]"
                  :placeholder="$t('Target')"
                  @input.prevent=""
                  @keyup.esc="toggleMetricEdit"
                  @keyup.enter="toggleMetricEdit"
                  @focusout="(event) => handleChange(event, metric.children[1])">
                <Check
                  class="hover:bg-gray-100 dark:hover:bg-dark-screen-background text-gray-500 h-10 w-10 block z-40 transition rounded-md duration-500 ease-in-out p-2 ml-1"
                  aria-hidden="true"
                  @click="toggleMetricEdit" />
              </div>
            </div>
          </td>
          <td class="px-6 py-3 h-12">
            <div v-if="metric?.children?.length && metric.children[2]" class="mt-1 flex items-center content-center gap 1">
              <div
                v-if="
                  !Object.keys(metric.children[2]).includes('edit') ||
                    (Object.keys(metric.children[2]).includes('edit') && metricEdit != metric.metricName)
                "
                class="text-[20px] flex max-w[30x] font-normal text-grey-light-body dark:text-dark-body-text">
                <span v-if="metric.symbolPre?.length">{{ metric.symbolPre }}</span>
                <span v-if="!(metric.symbolPre || metric.symbolPost)">{{ metric.children[2]?.value }}</span>
                <span v-if="metric.symbolPre || metric.symbolPost">{{
                  $utils.truncateNumber(
                    Number(metric.children[2]?.value?.toString().replaceAll(",", "")?.replace("$", "")?.replace("%", "").replace("-", ""))
                  )
                }}</span>
                <span v-if="metric.symbolPost?.length">{{ metric.symbolPost }}</span>
              </div>
              <div
                v-if="
                  !Object.keys(metric.children[2]).includes('edit') ||
                    (Object.keys(metric.children[2]).includes('edit') && metricEdit != metric.metricName)
                "
                class="ml-1 p-1 flex items-center content-center rounded-full"
                :class="
                  metric.children[2]?.value
                    ? metric.children[2]?.value?.toString().includes('-')
                      ? '!bg-status-error-red-transparent'
                      : '!bg-status-success-green-transparent'
                    : ''
                ">
                <ChevronDown
                  v-if="metric.children[2]?.value && metric.children[2]?.value?.toString().includes('-')"
                  class="h-3 w-3"
                  :class="
                    metric.children[2]?.value
                      ? metric.children[2]?.value.toString().includes('-')
                        ? '!text-status-error-red'
                        : '!text-status-success-green'
                      : '!text-status-warning-yellow'
                  " />
                <ChevronUp
                  v-if="metric.children[2]?.value && !metric.children[2]?.value?.toString().includes('-')"
                  class="h-3 w-3"
                  :class="
                    metric.children[2]?.value
                      ? metric.children[2]?.value.toString().includes('-')
                        ? '!text-status-error-red'
                        : '!text-status-success-green'
                      : '!text-status-warning-yellow'
                  " />
                <div
                  v-if="metric.children[2]?.value"
                  class="text-sm pr-1 text-center flex"
                  :class="
                    metric.children[2]?.value
                      ? metric.children[2]?.value?.toString().includes('-')
                        ? '!text-status-error-red'
                        : '!text-status-success-green'
                      : '!text-status-warning-yellow'
                  ">
                  <span v-if="metric.symbolPre?.length">{{ metric.symbolPre }}</span>
                  <span v-if="metric.children[2]?.value?.toString().includes('$')">$</span>
                  {{
                    $utils.truncateNumber(
                      Number(metric.children[2]?.value?.toString().replaceAll(",", "")?.replace("$", "")?.replace("%", "").replace("-", ""))
                    )
                  }}
                  <!--                {{ $utils.truncateNumber($utils.slugify(metric.children[2].value)) }}-->
                  <span v-if="metric.children[2]?.value?.toString().includes('%')">%</span>
                  <span v-if="metric.symbolPost?.length">{{ metric.symbolPost }}</span>
                </div>
                <div v-else class="-ml-2 text-common-grey w-32 flex flex-nowrap">
                  <span>{{ $t("No available data") }}</span>
                </div>
              </div>
              <div
                v-if="Object.keys(metric.children[2]).includes('edit') && metricEdit == metric.metricName && is_range_target_edit"
                class="mt-[5px] flex flex-row justify-start h-[25px] items-center">
                <input
                  :disabled="editing_disabled"
                  :value="metric.children[2].value"
                  type="number"
                  min="0"
                  class="w-[100px] h-[25px] appearance-none block mt-1 px-3 py-2 border border-light-divider-border dark:border-dark-divider-border rounded-md shadow-sm dark:bg-dark-box-background placeholder-common-grey text-light-body-text dark:text-dark-body-text focus:outline-none focus:ring-0 dark:focus:ring-dark-brand-blue focus:border-light-brand-blue dark:focus:border-dark-brand-blue text-sm transition ease-in-out duration-200 min-h-[42px]"
                  :placeholder="$t('Target')"
                  @input.prevent=""
                  @keyup.esc="toggleMetricEdit"
                  @keyup.enter="toggleMetricEdit"
                  @focusout="(event) => handleChange(event, metric.children[2])">
                <Check
                  class="hover:bg-gray-100 dark:hover:bg-dark-screen-background text-gray-500 h-10 w-10 block z-40 transition rounded-md duration-500 ease-in-out p-2 ml-1"
                  aria-hidden="true"
                  @click="toggleMetricEdit" />
                <span class="whitespace-nowrap text-sm mx-1 font-thin italic">
                  {{ selectedRange?.start.format("MM/DD/YY") }} - {{ selectedRange?.end.format("MM/DD/YY") }}
                </span>
              </div>
              <div
                v-else-if="Object.keys(metric.children[2]).includes('edit') && metricEdit == metric.metricName"
                class="mt-[5px] flex flex-row justify-start h-[25px] items-center">
                <input
                  :disabled="editing_disabled"
                  :value="metric.children[2].value"
                  type="number"
                  min="0"
                  class="w-[100px] h-[25px] appearance-none block mt-1 px-3 py-2 border border-light-divider-border dark:border-dark-divider-border rounded-md shadow-sm dark:bg-dark-box-background placeholder-common-grey text-light-body-text dark:text-dark-body-text focus:outline-none focus:ring-0 dark:focus:ring-dark-brand-blue focus:border-light-brand-blue dark:focus:border-dark-brand-blue text-sm transition ease-in-out duration-200 min-h-[42px]"
                  :placeholder="$t('Target')"
                  @input.prevent=""
                  @keyup.esc="toggleMetricEdit"
                  @keyup.enter="toggleMetricEdit"
                  @focusout="(event) => handleChange(event, metric.children[2])">
                <Check
                  class="hover:bg-gray-100 dark:hover:bg-dark-screen-background text-gray-500 h-10 w-10 block z-40 transition rounded-md duration-500 ease-in-out p-2 ml-1"
                  aria-hidden="true"
                  @click="toggleMetricEdit" />
              </div>
            </div>
          </td>
          <td class="px-1 py-3 h-12">
            <div class="relative flex items-center">
              <div @click.stop="">
                <Menu v-if="!editing_disabled" as="div" class="flex-shrink-0 ml-auto">
                  <MenuButton
                    class="inline-flex items-center justify-center text-gray-400 transition ease-in-out rounded duration-side-menu-transition-duration"
                    @click.stop="">
                    <span class="sr-only">{{ $t("Open options") }}</span>
                    <EllipsisVertical :color="$store.state.ui.darkMode ? '#fff' : ''" class="w-5 h-5 border-none" />
                  </MenuButton>
                  <transition
                    enter-active-class="transition duration-100 ease-out"
                    enter-from-class="transform scale-95 opacity-0"
                    enter-to-class="transform scale-100 opacity-100"
                    leave-active-class="transition duration-75 ease-in"
                    leave-from-class="transform scale-100 opacity-100"
                    leave-to-class="transform scale-95 opacity-0">
                    <MenuItems
                      v-if="!metricEdit"
                      class="absolute right-0 z-30 flex flex-col items-start content-center justify-center p-2 mx-3 mt-1 origin-top-right bg-white rounded-md shadow-lg outline-none dark:bg-dark-screen-background ring-1 ring-black ring-opacity-5 focus:outline-none">
                      <MenuItem
                        v-slot="{ active }"
                        @click.prevent="
                          () => {
                            toggleMetricEdit(metric.metricName)
                          }
                        ">
                        <div
                          :class="[
                            active ? 'text-gray-900 dark:text-dark-body-text' : 'text-gray-600 dark:text-dark-body-text',
                            'group flex items-center px-3 py-2 text-sm'
                          ]">
                          <Pencil class="w-5 h-5 mr-4" aria-hidden="true" />
                          <span class="whitespace-nowrap">{{ $t("Edit Target") }}</span>
                        </div>
                      </MenuItem>
                      <MenuItem
                        v-slot="{ active }"
                        @click.prevent="
                          () => {
                            toggleMetricEdit(metric.metricName, 'range-target')
                          }
                        ">
                        <div
                          :class="[
                            active ? 'text-gray-900 dark:text-dark-body-text' : 'text-gray-600 dark:text-dark-body-text',
                            'group flex items-center px-3 py-2 text-sm'
                          ]">
                          <Pencil class="w-5 h-5 mr-4" aria-hidden="true" />
                          <span class="whitespace-nowrap">{{ $t("Set current range target") }}</span>
                        </div>
                      </MenuItem>
                    </MenuItems>
                  </transition>
                </Menu>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { ChevronDown, ChevronUp, Check, EllipsisVertical, Pencil } from "lucide-vue-next"
import dataService from "@/services/data.service"
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue"

export default {
  components: {
    Pencil,
    EllipsisVertical,
    ChevronUp,
    Check,
    ChevronDown,
    Menu,
    MenuButton,
    MenuItems,
    MenuItem
  },

  inject: ["canUserEditLayout"],
  props: ["label", "metricsTable", "selectedRange"],
  emits: ["done"],
  data() {
    return {
      metricEdit: false,
      is_range_target_edit: false
    }
  },

  computed: {
    editing_disabled() {
      let editing_disabled_calc = false
      if (this.$route.name == "WorkspaceItem" && this.$store.state.ui.workspace_user_access_scope == "read") {
        editing_disabled_calc = true
      }

      if (this.$route.name == "Dashboard" && this.$route.params.page) {
        const current_template = this.$store.state.portfolio.shared_layouts.find((l) => l.id == this.$route.params.page)
        if (!this.canUserEditLayout(this.$store.state.auth.user, current_template)) {
          editing_disabled_calc = true
        }
      }

      return editing_disabled_calc
    }
  },
  methods: {
    toggleMetricEdit(metricName, type) {
      if (type == "range-target") {
        this.is_range_target_edit = true
      }
      if (this.metricEdit) {
        this.is_range_target_edit = false
        this.metricEdit = null
      } else {
        this.metricEdit = metricName
      }
    },
    updateForecastScale(item, newValue) {
      let data = {}
      if (this.is_range_target_edit) {
        dataService
          .updateForecast(this.$store.state.data.current_forecast.id, {
            range_goals: this.$store.state.data.current_forecast.range_goals.concat([
              {
                name: item["name"],
                goal: Number(newValue),
                from_date: this.$moment(this.selectedRange?.start).format("YYYY-MM-DDTHH:mm:ss"),
                to_date: this.$moment(this.selectedRange?.end).format("YYYY-MM-DDTHH:mm:ss")
              }
            ])
          })
          .then((result) => {
            item["value"] = result.data[item["name"]]
            this.metricEdit = null
          })
          .then(() => {
            this.$emit("done", true)
          })
      } else {
        data[item["name"]] = Number(newValue)
        dataService
          .updateForecast(this.$store.state.data.current_forecast.id, data)
          .then((result) => {
            item["value"] = result.data[item["name"]]
            this.metricEdit = null
          })
          .then(() => {
            this.$emit("done")
          })
      }
    },
    handleChange(event, metric) {
      if (event.currentTarget.value > 0) {
        this.$store.dispatch("ui/showLoading")
        setTimeout(() => {
          this.$store.dispatch("ui/hideLoading")
        }, 100)
        this.updateForecastScale(metric, event.currentTarget.value)
      }
    }
  }
}
</script>
